// src/components/AboutUs.js
import React from 'react';
import './AboutUs.css';

function AboutUs() {
  // Inline style for the hero background image
  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL + '/about-hero.jpg'})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <section className="about-us-page">
      {/* About Hero Section */}
      <div className="about-hero" style={heroStyle}>
        {/* Dark overlay to improve text readability */}
        <div className="about-hero-overlay">
          <div className="about-hero-content">
            <h1>About Left Right Solutions</h1>
            <p>Empowering Businesses with Innovative Global Solutions</p>
          </div>
        </div>
      </div>

      {/* Mission and Vision */}
      <div className="mission-vision container">
        <div className="mission">
          <h2>Our Mission</h2>
          <p>
            To simplify global operations and deliver comprehensive consultancy 
            services that help businesses and individuals navigate complex challenges 
            with ease and confidence.
          </p>
        </div>
        <div className="vision">
          <h2>Our Vision</h2>
          <p>
            To be the leading one-stop platform for global solutions, 
            continuously innovating to provide unmatched services in visa assistance, 
            courier, attestation, and IT support.
          </p>
        </div>
      </div>

      {/* Our Story */}
      <div className="our-story container">
        <h2>Our Story</h2>
        <div className="story-content">
        <p>
          Left-Right Solutions was founded with a single goal: to streamline the often 
          convoluted processes of international business and travel. What began as a 
          small consultancy focused on visa assistance quickly expanded into a 
          multifaceted solution provider, offering a wide range of services including 
          courier, attestation, IT support, and more. Over the years, we’ve built a 
          global network of experts, ensuring our clients receive reliable, 
          up-to-date guidance no matter where they’re located.
        </p>
        <p>
          Today, we’re proud to be recognized by industry leaders and trusted by 
          businesses worldwide. Our commitment to innovation, transparency, and 
          exceptional customer service has helped us grow from a local startup to a 
          global powerhouse. We believe in forging lasting partnerships with our 
          clients—because when you succeed, we succeed.
        </p>
      </div>
      </div>

      {/* Team Section (Optional) */}
      {/* <div className="team-section container">
        <h2>Meet the Team</h2>
        <div className="team-grid">
          <div className="team-member">
            <img src="team-member1.jpg" alt="Team Member 1" />
            <h3>Jane Doe</h3>
            <p>Founder & CEO</p>
          </div>
          <div className="team-member">
            <img src="team-member2.jpg" alt="Team Member 2" />
            <h3>John Smith</h3>
            <p>Head of Operations</p>
          </div>
          <div className="team-member">
            <img src="team-member3.jpg" alt="Team Member 3" />
            <h3>Mary Johnson</h3>
            <p>Lead Consultant</p>
          </div>
          <div className="team-member">
            <img src="team-member4.jpg" alt="Team Member 4" />
            <h3>Michael Lee</h3>
            <p>IT Solutions Manager</p>
          </div>
        </div>
      </div> */}
    </section>
  );
}

export default AboutUs;
